import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withApollo } from "react-apollo";
import React from "react";

import { getTransactionByIdQuery } from "../../../services/graphql/queries/auto-numbering";
import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import AutoNumberingView from "./autoNumberingView";
import AutoNumberingDetails from "./autoNumberingDetails";
import queryString from "query-string";

class AutoNumberingProfile extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      errors: [],
      error: "",
      user: {},
      userDetails: {}
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.props.client
      .query({
        query: getTransactionByIdQuery,
        variables: {
          id: parseInt(queryString.parse(this.props.location.search).id)
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const user = result.data.getTransactionById;

        this.initialState = {
          user: user
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.getTransactionById);
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
    this.setState({
      isCreated: queryString.parse(this.props.location.search).success
        ? true
        : false
    });
    setTimeout(() => {
      this.setState({ isCreated: false });
    }, SET_TIMEOUT_VALUE);
  }

  render() {
    const { loading, error, user } = this.state;

    // if (error) return <div>{error}</div>;
    // if (loading) return <div>Fetching...</div>;
    return (
      <>
        <AutoNumberingView user={user} userDetails={this.state.userDetails} />
        <AutoNumberingDetails user={user} />
      </>
    );
  }
}

AutoNumberingProfile.getInitialProps = ({ router }) => {
  return { router };
};

export default withRouter(connect()(withApollo(AutoNumberingProfile)));
